import { AddressWithComponents } from '@/form/types/smarty-streets/address-with-components';
import { Suggestion } from '@/form/types/smarty-streets/suggestion';

export function suggestionToAddress(suggestion: Suggestion) {
  return `${suggestion.streetLine}, ${suggestion.city}, ${suggestion.state} ${suggestion.zipcode}`;
}

export function suggestionsToAddresses(
  suggestions: Suggestion[]
): AddressWithComponents[] {
  const addressMap: { [address: string]: Suggestion } = {};

  suggestions.forEach((suggestion) => {
    const address = suggestionToAddress(suggestion);
    if (!addressMap[address]) {
      addressMap[address] = suggestion;
    }
  });

  return Object.entries(addressMap).map(([address, components]) => ({
    address,
    components,
  }));
}
